




























































import Vue from 'vue';
import { ScheduleRule, ScheduleRuleType } from '../../models/ScheduleRule';
import ruleClient from '../../apis';
import RiskBox from 'common/components/ui/RiskBox/index.vue';
import SidePage from 'common/components/ui/SidePage/index.vue';
import RuleStatistics from './RuleStatistics.vue';
import { ScheduleEventType, TraceEventType } from '../../models/ScheduleEventParam';
import { showFixedDelay } from '../../models/ScheduleDelay';
import commonVuex from '../../../common/vuex/common';
import Topic from '../../../settings/models/Topic';
import format from '../../../customer/components/filter/makeCustomerQuery';
import Filters from '../../../customer/vuex/filters';

export default Vue.extend({
  mixins: [commonVuex],
  props: {
    rule: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    remarks: {
      type: Array as () => any[],
      default: [],
    },
  },
  components: {
    RiskBox,
    SidePage,
    RuleStatistics,
  },
  data() {
    return {
      showDeleteBox: false,
      showStatistics: false,
      ScheduleRuleType,
      TraceEventType,
    };
  },
  computed: {
    ruleTypeAlias(): string {
      if (this.rule.scheduleRule.ruleType === ScheduleRuleType.TimeField) {
        return 'calendar';
      } else if (this.rule.scheduleRule.ruleType === ScheduleRuleType.Periodic) {
        return 'target';
      } else {
        return 'event';
      }
    },
    filterNothing(): boolean {
      const filter = format.query2Filter(this.rule.scheduleRule.ruleContext.Periodic.query);
      return !Filters.isFilterSex(filter) &&
             !Filters.isFilterSubscribe(filter) &&
             !Filters.isFilterArea(filter) &&
             !Filters.isFilterSubscribeScene(filter) &&
             !Filters.isFilterInteract(filter) &&
             !Filters.isFilterTrace(filter) &&
             !Filters.isFilterScore(filter) &&
             !Filters.isFilterScoreSum(filter) &&
             !Filters.isFilterMember(filter) &&
             !Filters.isFilterGroup(filter) &&
             !Filters.isFilterRemark(filter) &&
             !Filters.isFilterCustom(filter);
    },
  },
  methods: {
    editRule(rule: ScheduleRule) {
      this.$emit('showEdit', rule);
    },
    deleteRule(rule: ScheduleRule) {
      ruleClient.deleteRule({
        id: rule.id,
      }).success((r: any) => {
        this.$Message.success('删除成功');
        this.showDeleteBox = false;
        this.$emit('refresh');
        this.$store.commit('DELETE_SCHEDULE_RULE', rule.id);
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    ruleDesc(rule: ScheduleRule): string {
      let sendType = '';
      if(rule.scheduleMsg && rule.scheduleMsg.WxTpl) {
        sendType = '通过模板消息';
      } else if (rule.scheduleMsg && !rule.scheduleMsg.WxTpl){
        sendType = '通过客服消息';
      }
      let display = '';
      if (rule.ruleType === ScheduleRuleType.Event) {
        const eventTriggered = rule.ruleContext.EventTriggered;
        if (eventTriggered.eventType === ScheduleEventType.Follow) {
          display += '关注公众号，';
        } else if (eventTriggered.eventType === ScheduleEventType.RemarkAppended) {
          display += `首次打上标签“${eventTriggered.param.RemarkAppended.remarkName}”，`;
        } else if (eventTriggered.eventType === ScheduleEventType.ScoreReached) {
          display += `积分到达${eventTriggered.param.ScoreReached.score}，`;
        } else if (eventTriggered.eventType === ScheduleEventType.MemberLevelUp) {
          display += `成为会员“${eventTriggered.param.MemberLevelUp.title}”，`;
        } else if (eventTriggered.eventType === ScheduleEventType.TraceAppended) {
          display += `触发轨迹“${TraceEventType.find(t => t.value === eventTriggered.param.TraceAppended.traceOuterType).title}”，`;
        } else {}
        const delay = rule.ruleContext.EventTriggered.delay;
        if (delay.Nearest) {
          display += `${delay.Nearest.days}天后 ${delay.Nearest.time.substring(0, 5)} ${sendType}推送`; 
        } else if (delay.Fixed.amount === 0) {
          display += `${sendType}立即推送`;
        } else if (delay.Fixed) {
          display += `${showFixedDelay(delay.Fixed)}后${sendType}推送`;
        }
        return display;
      } else if (rule.ruleType === ScheduleRuleType.Periodic) {
        const tfb = rule.ruleContext.Periodic;
        let target = '';
        if (tfb.query.topics && tfb.query.topics.length > 0) {
          const topic = this.topics.find((t: Topic) => t.id === tfb.query.topics[0]);
          const name = topic ? topic.name : '';
          target = `订阅用户（${name}）`;
        } else {
          target = this.filterNothing ? '全部粉丝' : '部分粉丝';
        }
        target += `，定期${sendType}推送`;
        return target;
      } else {
        const tfb = rule.ruleContext.TimeFieldBased;
        let timestamp = '当天';
        if (tfb.triggerDayOffset !== 0) {
          timestamp = tfb.triggerDayOffset > 0 ? '后' : '前';
          timestamp += `${tfb.triggerDayOffset}天`;      
        }
        const propName = rule.ruleContext.TimeFieldBased.prop ? rule.ruleContext.TimeFieldBased.prop.propName : '';
        return [
          `距离“${propName}”${timestamp}`,
          tfb.triggerTime.substring(0, 5),
          `${sendType}推送`].join(' ');
      }
    },
  },
});
